export function splitName(name: string): { firstName: string; lastName: string } {
    const trimmedName = name.trim();
    const parts = trimmedName.split(/\s+/);
    const firstName = parts.shift() || '';
    const lastName = parts.join(' ') || '';
    return { firstName, lastName };
}

export const removeNonDigits = (value: unknown) => {
    if (!value || typeof value !== 'string') {
        return '';
    }
    return value.replaceAll(/\D/g, '');
};

export const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const getInitials = (firstName = '', secondName = ''): string => {
    const [first = ''] = firstName;
    const [last = ''] = secondName;
    return `${first}${last}`.trim();
};

export const joinFirstLast = (firstName: string | null = '', lastName: string | null = ''): string => {
    return `${firstName ?? ''} ${lastName ?? ''}`.trim();
};

type PluralConfig<T extends string> = Partial<Record<Intl.LDMLPluralRule, T>>;
const enUsPluralRules = new Intl.PluralRules('en-US');
export const pluralize = <T extends string>(count = 0, pluralOptions: PluralConfig<T>): T | undefined => {
    return pluralOptions[enUsPluralRules.select(count)];
};

export const ssnRegex = /^\d{3}-\d{2}-\d{4}$/;
export const einRegex = /^\d{2}-\d{7}$/;
export const zipRegex = /^\d{5}(-?\d{4})?$/;

/**
 * Convert a snake_case string to Sentence case.
 * Example:
 *   'not_insured' => 'Not insured'
 */
export function snakeToSentenceCase(snake: string | null): string {
    if (!snake) return '';
    const sentence = snake
        .split('_')
        .filter(word => word.length)
        .map((word, idx) => (idx === 0 ? toSentenceCase(word) : word.toLowerCase()))
        .join(' ');
    return sentence.trim();
}

/**
 * Capitalize the first letter and lowercase the rest of a string.
 * Example:
 *   'croissant' => 'Croissant'
 *   'HELLO' => 'Hello'
 */
export function toSentenceCase(str: string | null): string {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
